const rgbaToHexAndAlpha = (rgba: string): { hex: string; alpha: number } => {
    const match = rgba.match(
        /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*([01]?\.?\d*))?\s*\)$/
    );

    if (!match) {
        throw new Error(`Format RGBA invalide: ${rgba}`);
    }

    const r = Number(match[1]);
    const g = Number(match[2]);
    const b = Number(match[3]);
    const alpha = match[4] !== undefined && match[4] !== "" ? Number(match[4]) : 1;

    const toHex = (value: number): string => value.toString(16).padStart(2, "0");

    const hex = `#${toHex(r)}${toHex(g)}${toHex(b)}`;

    return {
        hex,
        alpha,
    };
};

export default rgbaToHexAndAlpha;